export async function showProductUseCase(product_id, productRepository) {
    const result = await productRepository.show(product_id);

    const product = new productRepository.model(result);
    
    if (!product.isValid()) {
        throw new Error("dropdown product inválido");
    }

    return product;
}